export class GetUserProfileAction {
  static readonly type = '[Account] GetUserProfileAction';
}

export class UploadProfileImageAction {
  static readonly type = '[Account] UploadProfileImageAction';
  constructor(public payload:{
    fileType:string,
    newProfileImage: string
  }) {}
}
export class GetProfileImageAction {
  static readonly type = '[Account] GetProfileImageAction';
}

export class ReferFriendAction {
  static readonly type = '[Account] ReferFriendAction';
  constructor(public payload:{email: string, link: string}) {}
}
export class GetPartnerAssociatedAction {
  static readonly type = '[Account] GetPartnerAssociated';
}




